export default __webpack_public_path__ + "5f41c6358c18a824f5f6a9922dae141a.png";